import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { addMessage } from 'researcher/application/actions';
import { fetchUserRewardPoints, loadNumberOfOrders } from 'researcher/user/actions';
import { fetchOrderCertificate, fetchOrders, getDownloadUrl, loadPaymentInformation, loadServices, saveOrder, updateCertificate, updateEmailNotificationSettings } from '../actions';
import { getDisplayJournal, getOrder, getExcludedFileTypes, getReeditMessageTerm, getShowStyleOfEnglish } from '../reducer';
import OrderDetails from './OrderDetails';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    dashboard = _ref.dashboard,
    user = _ref.user;
  var match = _ref2.match,
    state = _ref2.location.state;
  return {
    displayInvoices: !user.hideInvoices,
    displayJournal: getDisplayJournal({
      dashboard: dashboard,
      match: match,
      user: user
    }),
    displayPreprintCampaign: application.config.displayPreprintCampaign && (application.siteLanguage === 'en' || application.siteLanguage === 'cn'),
    excludedFileTypes: getExcludedFileTypes({
      dashboard: dashboard,
      match: match
    }),
    externalId: match.params.externalId,
    showStyleOfEnglish: getShowStyleOfEnglish({
      dashboard: dashboard,
      match: match
    }),
    newOrder: match.params.status === 'thank-you',
    order: getOrder({
      dashboard: dashboard,
      match: match
    }),
    reeditMessageTerm: getReeditMessageTerm({
      dashboard: dashboard,
      match: match
    }),
    returnUrl: state && state.previousPath ? state.previousPath : '/researcher',
    siteLanguage: application.siteLanguage,
    status: dashboard.orders.status,
    userHasRewards: user.hasRewards,
    userIdentity: user.identity
  };
};
export var mapDispatchToProps = {
  addMessage: addMessage,
  fetchOrderCertificate: fetchOrderCertificate,
  fetchOrders: fetchOrders,
  fetchUserRewardPoints: fetchUserRewardPoints,
  getDownloadUrl: getDownloadUrl,
  loadNumberOfOrders: loadNumberOfOrders,
  loadPaymentInformation: loadPaymentInformation,
  loadServices: loadServices,
  saveOrder: saveOrder,
  updateCertificate: updateCertificate,
  updateEmailNotificationSettings: updateEmailNotificationSettings
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderDetails));